import React from 'react';
import Helmet from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

import breakpoints from './styles/breakpoints';

import ScrollToTop from './components/ScrollToTop';
import GenerateMetaTags from './components/GenerateMetaTags';
import Header from './components/Header';
import Routes from './routes/Routes';
import Footer from './components/Footer';
import GlobalStyles from './styles/GlobalStyles';

const Main = styled.div`
  padding: 0 ${props => props.theme.gutterSmall};
  margin-bottom: 20px;

  ${breakpoints.medium`
        padding: 0 ${props => props.theme.gutter};
    `};
`;

export default function App() {
  return (
    <ScrollToTop>
      <div>
        <GlobalStyles />

        <Helmet>
          {GenerateMetaTags({
            title: 'Bil1Din',
            description:
              'Vi har alt du trenger av brukte bildeler. Forhandler også fabrikkoverhalte motorer og gearkasser. Snakk med oss når du skal ha deler til bilen din.'
          })}

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@publisher_handle" />
          <meta name="twitter:creator" content="@author_handle" />
          <meta property="fb:admins" content="Facebook numeric ID" />
          <meta property="og:site_name" content="Site Name" />
        </Helmet>

        <Header />

        <Main>
          <Routes />
        </Main>

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />

        <Footer />
      </div>
    </ScrollToTop>
  );
}
